<template>
  <modal-wrapper :shown="shown" title="Copy Subscribers" @close-modal="onCloseModal">
    <template v-if="campaigns.length">
      <p><strong class="text-white">Select a campaign from which you want to copy the subscribers.</strong></p>

      <select class="select form-control" @change="onSelectCampaign">
        <option></option>
        <option v-for="campaign of campaigns" :key="campaign.id" :value="campaign.id">
          {{ campaign.name }} (ID: {{ campaign.id }})
        </option>
      </select>

      <button class="actionButton m-0" :disabled="!selectedCampaignId || processing" @click="onCopyClick">
        Copy Subscribers
      </button>
      <modal-processing-indicator v-if="processing"></modal-processing-indicator>
    </template>

    <template v-else>
      <p>
        <strong class="text-white">There is no campaign with any subscribers.</strong>
      </p>

      <button class="actionButton" @click="onCloseModal">
        Go Back
      </button>
    </template>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '../../modal/ModalWrapper';
import ModalProcessingIndicator from '../../modal/ModalProcessingIndicator';
import {handleActionModalResponse} from '../../../utility/modal/handleActionModalResponse';
import {copyCampaignSubscribers} from '../../../utility/api/campaign/copyCampaignSubscribers';
import {getVesselCampaignsHasMembers} from '../../../utility/api/campaign/getVesselCampaignsHasMembers';

export default {
  name: 'copy-subscribers-modal',
  components: {ModalWrapper, ModalProcessingIndicator},
  data() {
    return {
      campaigns: [],
      processing: false,
      selectedCampaignId: null,
    };
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    shown: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    shown(value, previousValue) {
      if (!value && previousValue) {
        this.processing = false;
        this.selectedCampaignId = null;
      }
    },
  },
  methods: {
    onCopyClick() {
      copyCampaignSubscribers(this.selectedCampaignId, this.campaignId, true).then(response => {
        if (handleActionModalResponse(response, window.location.pathname)) {
          this.$emit('close-modal');
        }
      });
    },
    onSelectCampaign(event) {
      this.selectedCampaignId = Number(event.target.value);
    },
    onCloseModal() {
      this.$emit('close-modal');
    },
    async getCampaignsWithContacts() {
      const campaigns = await getVesselCampaignsHasMembers();
      return campaigns.filter(campaign => campaign.id !== this.campaignId);
    },
  },
  async created() {
    this.campaigns = await this.getCampaignsWithContacts();
  },
};
</script>

<style lang="scss" scoped>
select {
  width: auto;
  margin: 30px auto;
}
</style>
